import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemSelectionClass } from '../../../../../core/services/menu/menu-item-selection.service';
import { getValueFromJson } from '../../../../../core/utils/get-value-from-json.utils';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';

interface IPageCp2018 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any;
}
/* @ngInject */
export default function Cp2018Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemEcran: IMenuItemEcranClass,
    cp2019Route: IRoute,
    cp2005Route: IRoute,
    Menu: IMenuClass,
    MenuItemSelection: IMenuItemSelectionClass,
    MenuItemForage: IMenuItemForageClass,
    ecranDetails: IEcranDetailsResourcesEntite) {
    const vm: IPageCp2018 = this;
    vm.valeursEcran = ecranDetails.valeurs;
    const menuForage = [
        new MenuItemForage(
            'BTN_FORAGE_PFL',
            cp2005Route.NAME,
            (rowData: any) => ({
                id: rowData.trncleint
            }),
            {
                icon: 'exit_to_app',
                hidden: (data: any) => !data?.trncleint
            }
        )
    ];

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false,
            criteresSuggeresVisibles: true,
            supprime: false,
            edition: false
        },
        actionsSelection:
            new Menu([
                new MenuItemSelection('LBL_TRAITER_MANUELLEMENT', 'BOUTRA', {
                    selection: {
                        nom: 'traiter',
                        lblConfirm: 'G_LBL_EXECUTER',
                        lblConfirmationTitre: 'LBL_TRAITER_MANUELLEMENT',
                        largeurFormulaire: 50,
                        confirmationFormulaire: new Formulaire([
                            new FormulaireItem('rpcetatnewdsc', { default: getEtatText(2), readonly: true }),
                            new FormulaireItem('rpcetatnew', { default: 2, readonly: true, hidden: true })
                        ], { largeurDefaut: 30 }),
                    }
                }),
                new MenuItemSelection('LBL_NE_PAS_TRAITER', 'BOUTRA', {
                    selection: {
                        nom: 'traiter',
                        lblConfirm: 'G_LBL_EXECUTER',
                        lblConfirmationTitre: 'LBL_NE_PAS_TRAITER',
                        largeurFormulaire: 50,
                        confirmationFormulaire: new Formulaire([
                            new FormulaireItem('rpcetatnewdsc', { default: getEtatText(3), readonly: true }),
                            new FormulaireItem('rpcetatnew', { default: 3, readonly: true, hidden: true })
                        ], { largeurDefaut: 30 }),
                    }
                })
            ], {
                disabled: (rowData: any) => rowData.rpcetat === '1',
            }),
        criteresSuggeres: new Formulaire([
            new FormulaireItem('rpcetat', { required: true }),
            new FormulaireItem('rpcemailsubject'),
            new FormulaireItem('rpcdatereception'),
            new FormulaireItem('zranumdoc'),
            new FormulaireItem('rpcdsc')
        ]),
        fileDownloadPreview: {
            isRowWithBtnFunction: null,
            col: {
                nom: 'pjbfichier',
                largeur: 110,
            },
            download: {
                hidden: (rowData: any): boolean => !rowData['pjbcleint']
            },
            preview: {
                hidden: (rowData: any): boolean => !rowData['vaesystypfic']
            },
            url: {
                nomFonctionDownload: 'BOUSOR',
                nomFonctionPreview: 'BOUSOR',
                srccodBloc: 'cp2018',
                getCleFunction: (data: any): string => data['pjbcleint']
            }
        },
        colonnesVisibles: [
            { nom: 'rpcetatdsc', largeur: 180 },
            { nom: 'rpcemailsubject', largeur: 180 },
            { nom: 'rpcdateenvoi', largeur: 180, hideFromRecherche: true },
            { nom: 'rpcdatereception', largeur: 180 },
            { nom: 'zranumdoc', largeur: 220, menu: menuForage },
            {
                nom: 'rpcdetail', largeur: 100, hideFromRecherche: true, menu: [
                    new MenuItemEcran(
                        '',
                        cp2019Route.NAME,
                        (rowData: any) => ({
                            id: rowData.rpcoucleint
                        }),
                        {
                            icon: 'launch',
                            iconButton: false,
                            secondaire: true
                        })
                ]
            },
            { nom: 'rpcdsc', largeur: 200 }
        ],
        colonnesCachees: ['rpcoucleint', 'pjbcleint', 'pjbfichier', 'trncleint']
    };
    function getEtatText(etat: number) {
        let result = undefined
        const liste_etat_json=vm?.valeursEcran?.liste_etat_json
        if(!liste_etat_json) return result

        switch (etat) {
            case 1:
                result = getValueFromJson(liste_etat_json, '1')
                break;
            case 2:
                result = getValueFromJson(liste_etat_json, '2')
                break;
            case 3:
                result = getValueFromJson(liste_etat_json, '3')
                break;
            default:
                break;
        }
        return result
    }
}
